module.exports = __webpack_public_path__ + "media/Lurking in the Underworld.b7b7518d.mp3";